<template>
	<div>
		<el-row :gutter="20">
      <el-col :span="2" class="p-t-40 f-w-600">{{orderInfo.autoType == 1 ? '手动流转：' : '自动流转：'}}</el-col>
			<el-col :span="19">
				<el-steps align-center class="el-card__body detail-step">
					<template v-for="item in this.orderInfo.flowList">
						<el-step :title="$flowType.get(item.orderFlow==4?item.flowLevel:item.orderFlow)" :status="getFlowStatus(item.status)">
							<template slot="description" slot-scope="scope" style="width: 350px;">
								<!-- -1.已终止，0未开始 1.待配置，2.待领取，3.进行中，4.已完成-->
								<span>（{{ item.status === -2?'进行中':$flowStatus.get(item.status) }}）</span>
								<br>
								<span v-if="item.updateTime!=null && item.status === -1 " v-text="formatCancelDate(item.updateTime)">//已取消</span>
								<br>
								<span v-if="item.startTime!=null" v-text="formatStartDate(item.startTime)"></span>
								<br>
								<span v-if="item.finishTime!=null && item.status === 4 " v-text="formatDate(item.finishTime)"></span>
								<br>
								<span>
									<el-tag v-if="item.status!==0 && item.status!==-1"
											@click="handleClick(item.orderFlow, item.id, item.status, item.flowLevel)" size="small"
											:type="item.status===1?'danger':'text'" style="cursor: pointer"
											v-text="item.status === 1?'去配置':'查看' "/>
								</span>
							</template>
						</el-step>
					</template>
				</el-steps>
			</el-col>
			<el-col :span="3" class="p-t-40">
				<el-button type="primary" size="medium"
						v-if="this.orderInfo.status === 1 &&this.canSubmit && permissions.dot_order_submit"
						@click.stop="presSubmitOrder()">提交订单
				</el-button>
			</el-col>
		</el-row>
		<div class="d-f align-c c-666 f-s-14 p-b-10">
			<div class="m-r-20">来源ID：{{ orderInfo.sourceId }}</div>
			<div class="m-r-20">订单号：{{ orderInfo.id }}</div>
			<div class="m-r-20">要求返稿格式：{{ orderInfo.tranFormat == 1 ? "纯译文" : "段段对照" }}</div>
			<div class="m-r-20">语种方向：{{ $sysLan.get(orderInfo.slan) }}-{{ $sysLan.get(orderInfo.tlan) }}</div>
			<el-button type="primary" size="small" plain @click.stop="returnList()">查看任务列表</el-button>
		</div>
		<el-tabs type="card" v-model="activeName" @tab-click="handleTabClick" >
			<el-tab-pane label="原稿" name="1">
				<fileDown v-if="this.orderInfo.id" :taskType="1" :type="1" :orderId="orderInfo.id" :staParams="this.staParams" key="ori" ref="ori"/>
			</el-tab-pane>
			<el-tab-pane label="成本信息" name="2">
				<avue-crud :option="costOption" :data="cotsInfo" ref="cost" >
					<!--1 机翻 2 一次打标 3 二次打标 4 PE 5 PE审核 6 质控-->
					<template slot="actionType" slot-scope="scope">
						<span>{{ $costType.get(scope.row.actionType) }}</span>
					</template>
					<template slot="actionCost" slot-scope="scope">
						<span>{{ scope.row.actionCost || 0 }}</span><span>{{scope.row.addCost?'(含加价成本'+scope.row.addCost+')':''}}</span>
					</template>
				</avue-crud>
				<br>
				<el-button type="primary" size="medium" v-if="this.downFile !=null " plain @click.stop="rowDown()">下载分析结果
				</el-button>
			</el-tab-pane>
			<el-tab-pane label="详细进度" name="3" v-if="showSenTab">
				<sentenceDetail :orderInfo="this.orderInfo" :orderId="this.$route.params.id" :staParams="this.staParams" key="sentt" ref="sentt"/>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import {cost, getObj, submit} from '@/api/dot/order'
import {statistics} from '@/api/dot/flow'
import {listFile} from '@/api/dot/file'
import {formatDate} from '@/util/date'
import {mapGetters, mapState} from "vuex";
import {errorSubmitOrderMsg} from '@/util/commonMsg.js'
import fileDown from '@/views/common/fileDown'
import sentenceDetail from '@/views/dot/order/order-detail-sentence'

export default {

  components: {fileDown, sentenceDetail},
  data() {
    return {
      page: false,
      orderInfo: {},
      downFile: null,
      fileData: [],
      cotsInfo: [],
      activeName: "1",
      orderTid:"",
      costOption: {
        card: true,
        refreshBtn: false,
        header: false, //表格头部中间菜单
        page: false,
        menu: false,
        addBtn: false, //新增按钮
        columnBtn: false,
        delBtn: false,
        editBtn: false,
        showSummary: true,
        sumColumnList: [
          {
            label: '合计：',
            name: 'actionCost',
            type: 'sum',
            decimals: 2
          }
        ],
        column: [{
          label: '成本类型',
          prop: 'actionType',
          slot: true
        }, {
          label: '金额',
          prop: 'actionCost',
          slot: true
        }]
      },
      isViewPdf: false,
      pdfSrc: '',
      allDownArr: [],
      allCostNum: '',
      canSubmit: false,
      showSenTab:false,
      staParams: null,
    }
  },
  
  computed: {
    ...mapGetters(['permissions']),
    ...mapState({
      userInfo: state => state.user.userInfo
    }),
  },
  updated() {
    if(this.activeName === "1") {
      this.$nextTick(()=>{
        this.$refs.ori.init();
      })
    } else if(this.activeName === "3") {
      this.$nextTick(()=>{
        this.$refs.sentt.loadPage();
      })
    }
  },

  beforeRouteEnter(to, from, next) {
    next(vm=>{
      vm.curPath = to.path;
      vm.oldPath = from.path;
    })
	},

  created() {
    this.init();
    this.staParams = {
      u_id: this.userInfo.staffId,
      time: new Date().getTime(),
      browser: navigator.userAgent.toLowerCase(),
      url: document.URL,
      ref_url: this.oldPath,
      scene_name: '订单详情'
    }
  },

  mounted() {
    this.statistics()
  },

  methods: {
    statistics() {
      statistics(Object.assign({
        event_type: 'view'
      }, this.staParams))
    },

    handleTabClick(tab, event) {
      this.activeName = tab.name
    },
    returnList() {
      this.$router.push({path: '/dot/order/index?sourceId=' + this.orderInfo.sourceId});
      statistics(Object.assign({
        event_name: '查看任务列表',
        event_type: 'click',
      }, this.staParams))
    },
    rowDown() {
      window.location.href = this.$stringFormat(this.downUrl, [this.downFile.fileUrl, this.downFile.fileName])
    },
    formatDate(time) {
      let date = new Date(parseFloat(time))
      return "完成时间：" + formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    },
    formatStartDate(time) {
      let date = new Date(parseFloat(time))
      return "开始时间：" + formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    },
    formatCancelDate(time) {
      let date = new Date(parseFloat(time))
      return "取消时间：" + formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    },
    init() {
      //订单信息
      getObj(this.$route.params.id).then(response => {
        this.orderInfo = response.data.data;
        if (this.orderInfo.id == null) {
          this.$message.error('未查询到数据');
          return
        }
        let submitTemp = true

        this.orderInfo.flowList.forEach(ele => {
          if (ele.status === 3) {
            submitTemp = false
          }
        })
        this.canSubmit = submitTemp
        cost(this.orderInfo.id).then(response => {
          this.cotsInfo = response.data.data;
        })
        listFile({orderId: this.orderInfo.id, fileType: 9}).then(response => {
          if (response.data.data && response.data.data.length > 0) {
            this.downFile = response.data.data[0]
          }
        })
        this.orderInfo.flowList.forEach(item => {
          if(item.orderFlow === 4 || item.orderFlow === 6){
            this.showSenTab = true
            this.activeName = "3"
          }
        })
      })
    },

    handleClick(orderFlow, flowId, status, flowLevel) {
      if (status === 0) {
        return
      }
      if (orderFlow === 1) {
        this.$router.push({path: '/dot/flow/detail-mt/' + flowId})
      } else if (orderFlow === 2) {
        this.$router.push({path: '/dot/flow/detail-marking/' + flowId})
      } else if (orderFlow === 4) {
        if(flowLevel == 3) {
          this.$router.push({
            path: '/dot/flow/detail-pe/' + flowId,
          })
        }
        if(flowLevel == 4) {
          this.$router.push({
            path: '/dot/flow/detail-review/' + flowId,
          })
        }
        if(flowLevel == 5) {
          this.$router.push({
            path: '/dot/flow/detail-peReview/' + flowId,
          })
        }
      } else if (orderFlow === 6) {
        this.$router.push({path: '/dot/flow/detail-qc/' + flowId, query: {orderId: this.orderInfo.id, type: 'pm'}})
      }
      statistics(Object.assign({
        event_name: '查看',
        event_type: 'click',
      }, this.staParams))
    },
    btnReturnSuccess(msg) {
      this.$message.success({
        message: msg, duration: 1500, onClose: () => {
          this.$router.replace({
            path: '/refresh'
          })
        }
      });
    },
    btnReturnFail(msg) {
      this.$message.error({
        message: msg, duration: 1500, onClose: () => {
          this.$router.replace({
            path: '/refresh'
          })
        }
      });
    },
    presSubmitOrder() {
      let hasNoStart
      let hasProcessing
      this.orderInfo.flowList.forEach(ele => {
        if (ele.status === 0 || ele.status === 1 || ele.status === 2) {
          hasNoStart = true
        } else if (ele.status === 3) {
          hasProcessing = true
        }
      })

      let msg = "确认提交订单？"
      if (hasNoStart) {
        msg = "您的项目还有未开始的任务，确认提交订单？提交后未开始的任务将变成取消状态"
      }

      this.$alert(msg, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showCancelButton: true,
        callback: action => {
          if (action === 'confirm') {
            submit(this.orderInfo.id).then(res => {
              if (res.data.data > 0) {
                this.btnReturnSuccess("提交成功");
              } else {
                this.btnReturnFail(errorSubmitOrderMsg(res.data.data));
              }
            })
          } else {
            this.$router.replace('/refresh')
          }
        },
      },);
    },
    getFlowStatus(status) {
      if (status === 3 || status === -2) {
        return "finish"
      } else {
        return "wait"
      }
    }
  },
}

</script>
<style lang="scss" scoped>
.avue-view {
  background: #FFFFFF;
  padding: 20px;
  min-height: calc(100vh - 100px);
}

</style>
